import dayjs from "dayjs";

import { CartState, RawCartResponse } from "@core/types";

export const getMonthOffsetDate = (monthOffset: number = 1): Date => {
  const date = dayjs().subtract(monthOffset, "month").toDate();
  return date;
};

export const convertSupaCartToCart = (cartFromSupa: RawCartResponse): CartState => {
  return {
    cartTotalValue: cartFromSupa.total,
    cartSubtotalValue: cartFromSupa.total + cartFromSupa.reward_points,
    cartProducts: cartFromSupa.products,
    cartProductsMap: cartFromSupa.products.reduce(
      (acc, product) => {
        acc[product.id] = product;
        return acc;
      },
      {} as CartState["cartProductsMap"],
    ),
    coupons: cartFromSupa.coupons,
    rewardPoints: cartFromSupa.reward_points,
    soldOutProducts: cartFromSupa.sold_out_products,
    unavailableProducts: cartFromSupa.unavailable_products,
    updatedAt: cartFromSupa.updated_at,
  };
};
